import React from 'react';
import { connect } from 'react-redux';
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';
import {
  getPopulationSetting,
  setPopulation,
  Populations,
} from '../../reducers/population';

export const Population = ({ population, popChange }) => (
  <DropDownMenu
    value={population}
    onChange={(e, i, val) => popChange(val)}
    autoWidth={false}
    className={'populationButton'}
    style={{
      height: '42px',
      lineHeight: '42px',
      fontSize: '14px',
      width: '220px',
      border: '10px',
      borderRadius: '2px',
      marginLeft: '5px',
      boxShadow:
        'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px',
    }}
    underlineStyle={{
      display: 'none',
    }}
    labelStyle={{
      height: '42px',
      lineHeight: '42px',
      backgroundColor: 'white',
    }}
    iconStyle={{
      width: '20px',
      fill: 'black',
      top: '-2px',
    }}
    iconButton={
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        // style={{ margin: '5px 10px -4px 7px' }}
      >
        <path d="M5 8l4 4 4-4z" />
      </svg>
    }
  >
    <MenuItem value={Populations.Big} primaryText=">1M Population" />
    <MenuItem value={Populations.Medium} primaryText="500K—1M Population" />
    <MenuItem value={Populations.Small} primaryText="<500K Population" />
    <MenuItem value={Populations.All} primaryText="All Cities" />
  </DropDownMenu>
);

export default connect(
  state => ({
    population: getPopulationSetting(state),
  }),
  {
    popChange: setPopulation,
  },
)(Population);



// WEBPACK FOOTER //
// ./src/components/Population/Population.jsx